import { useAtomValue } from "jotai";
import Konva from "konva";
import { useLayoutEffect, useRef } from "react";
import { Group } from "react-konva";
import { isAnyKindOfExportAtom } from "state-atoms";

const zeroRect = () => ({ x: 0, y: 0, width: 0, height: 0 });

export function ExcludeFrom({
  fromTransformer,
  fromExports,
  children,
}: React.PropsWithChildren<{ fromTransformer: boolean; fromExports: boolean }>) {
  const ref = useRef<Konva.Group>(null);
  const isExporting = useAtomValue(isAnyKindOfExportAtom);

  // This effect does the trick. If we are to exclude the content
  // from the transformer, we just replace the client-rect with zero (that's enough)
  // Of course, don't replace it if we're exporting and we want to keep the item
  useLayoutEffect(() => {
    if (ref.current && fromTransformer) {
      if (isExporting && !fromExports) return;
      const node = ref.current as any;
      const prev = node.getClientRect;
      node.getClientRect = zeroRect;
      return () => {
        node.getClientRect = prev;
      };
    }
  }, [fromTransformer, isExporting, fromExports]);

  // Another trick: if directed to exclude from export, don't render the children
  return <Group ref={ref}>{isExporting && fromExports ? null : children}</Group>;
}
